var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"bannerTemplates"}},[_c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v(_vm._s(_vm.nomePagina))])])])}
var staticRenderFns = []

export { render, staticRenderFns }